export enum OperatingSystem {
    Windows = 0,
    Linux = 1,
    MacOs = 2,
    Web = 3,
    Android = 4,
    IOS = 5
}

/**
 * These key will be translated by enum & cp_dropbox.
 * Therefore keys are displayed as unused and have weird keys
 */
export enum ProductState {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    productSateDraft = 0,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    productSateAvailable = 1,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    productSateArchived = 2,
}

